module.exports = __webpack_public_path__ + "c5ba0b967402b9812e6b57531d77830a.mp4";